import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/js/main'; // Import the JS file from assets
import About from './pages/About';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Services from './pages/Services';
import ServicesDetails from './pages/ServicesDetails';
import WhatsAppButton from './Component/WhatsAppButton';
import ScrollToTop from './Component/ScrollToTop';

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/about' element={<About/>}/>
        <Route path='/services' element={<Services/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/service/:category_id/:name' element={<ServicesDetails/>}/>
      </Routes>
       <WhatsAppButton />
      </BrowserRouter>

    
    </>
  );
}

export default App;
